import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface CleanUpProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const CleanUp: React.FC<CleanUpProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [cleanUp, set_cleanUp] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Final Steps']?.['Clean Up'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Final Steps': { ...b.values?.['Final Steps'], 'Clean Up': v } } })
    );
    const label = 'Clean Up';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(cleanUp)}
                />
            ) : (
                <MoneyBox
                    id={'cleanUp'}
                    allowNegative={false}
                    value={cleanUp}
                    onChange={(value) => set_cleanUp(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
